import {Component, Vue} from "vue-property-decorator";
import {AuthService} from "@/services/auth";
import {IAuthenticatedEmployee} from "shared/entities/employee";

@Component
export default class EmployeeMixin extends Vue {

    public getAuthenticatedEmployee(): Promise<IAuthenticatedEmployee> {
        return AuthService.getSelf();
    }

    public async authorized(): Promise<boolean> {
        try {
            await this.getAuthenticatedEmployee();
            return true;
        } catch {
            return false;
        }
    }

    public async deauthorize(): Promise<void> {
        await AuthService.clearToken();
    }
}
